<template>
  <transition name="fade">
    <div v-if="show" :class="rootClass" class="concept-root">
      <div class="sp-section first">
        <div class="bgs">
          <div :style="bg1Style" class="bg bg1"></div>
          <div :style="bg2Style" class="bg bg2"></div>
        </div>

        <transition name="fade">
          <div v-if="scrollRate < 0.8" class="main-texts">
            <div class="text-1">
              <span :style="text1Part1Style" class="part part1">にほん</span>
              <span :style="text1Part2Style" class="part part2">がすき。</span>
              <br />
              <span :style="text1Part2Style" class="part part3">だから、</span>
              <span :style="text1Part4Style" class="part part4">繋いで、</span>
              <br />
              <span :style="text1Part5Style" class="part part5">幸せに。</span>
            </div>
            <div class="text-2">
              <div :style="text2Part1Style" class="part1">Nihon Ga Suki.</div>
              <div :style="text2Part2Style" class="part2">
                Dakara, Tsunaide, Shiawase ni.
              </div>
            </div>
          </div>
        </transition>
      </div>

      <div class="sp-section second">
        <div class="texts-wrapper">
          <div class="texts">
            <div :style="text3Part1Style" class="part part1 text">
              美しい海や豊かな自然。便利で最先端の都市環境。
              <br />
              これはどちらも、日本が世界に誇れる大きな魅力。
              <br />
              どちらかしか経験できないなんて、もったいない。
            </div>

            <div :style="text3Part2Style" class="part part2 text">
              NGS（Nihon Ga Suki）は、
              <br />
              この国を、この国で暮らす人々を、もっともっと繋いでいきたい。
              <br />
              都心と地方のどちらにも拠点を構え、
              <br />
              個々人が自由に働く場所を移しながら
              <br />
              その土地の魅力を実感できるようにしたい。
            </div>

            <div :style="text3Part3Style" class="part part3 text">
              今はまだ、世田谷と高知にしかないけれど、
              <br />
              もっと多くの素敵な場所を見つけていって、
              <br />
              デュアルライフを超えたパラレルライフを実現する。
            </div>

            <div :style="text3Part4Style" class="part part4 text">
              それが、システムとシステムを繋ぐAPI連携を
              <br />
              メインサービスとしている僕らの、
              <br />
              もう一つの“繋ぐ”挑戦。
            </div>
          </div>
        </div>
      </div>
    </div>
  </transition>
</template>

<script>
import {
  spFadeStyle1,
  spTransformStyle1,
  spFadeStyle2,
  spTransformStyle2
} from '../../lib/spStyleGenerator'

export default {
  name: 'pageSpConcept',
  computed: {
    scrollRate() {
      return this.$store.getters.conceptPageRate
    },

    show() {
      const currentPage = this.$store.getters.currentPage

      return currentPage === 'concept'
    },

    rootClass() {
      return this.scrollRate <= 0.5 ? 'first' : 'second'
    },

    text1Part1Style() {
      return {
        ...spFadeStyle1(this.scrollRate),
        ...spTransformStyle1(this.scrollRate, { scale: 1.5 })
      }
    },
    text1Part2Style() {
      return {
        ...spTransformStyle1(this.scrollRate, { y: 50 })
      }
    },
    text1Part4Style() {
      return {
        ...spTransformStyle1(this.scrollRate, { y: 100 })
      }
    },
    text1Part5Style() {
      return {
        ...spTransformStyle1(this.scrollRate, { y: 100, scale: 1.5 }),
        ...spFadeStyle1(this.scrollRate)
      }
    },
    bg1Style() {
      return {
        ...spTransformStyle1(this.scrollRate, { y: 50 }),
        ...spFadeStyle1(this.scrollRate)
      }
    },
    bg2Style() {
      return {
        ...spTransformStyle1(this.scrollRate, { x: -100 })
      }
    },
    text2Part1Style() {
      return {
        ...spTransformStyle1(this.scrollRate, { x: 20 })
      }
    },
    text2Part2Style() {
      return {
        ...spTransformStyle1(this.scrollRate, { x: 50 })
      }
    },
    text3Part1Style() {
      return {
        ...spTransformStyle2(this.scrollRate, { y: 100 })
      }
    },
    text3Part2Style() {
      return {
        ...spTransformStyle2(this.scrollRate, { x: -50, y: -50, scale: 1.2 }),
        ...spFadeStyle2(this.scrollRate)
      }
    },
    text3Part3Style() {
      return {
        ...spTransformStyle2(this.scrollRate, { x: -10, y: 50 }),
        ...spFadeStyle2(this.scrollRate)
      }
    },
    text3Part4Style() {
      return {
        ...spTransformStyle2(this.scrollRate, { y: 100 })
      }
    }
  }
}
</script>

<style lang="sass" scoped>
.bgs
  overflow-x: hidden
  height: 600px
  position: relative

.bg
  position: absolute
  background-size: cover
  width: 375px
  height: 250px
  &1
    left: 115px
    top: 253px
    background-image: url('/images/bg/bg1.jpg')
  &2
    left: -200px
    top: 200px
    background-image: url('/images/bg/bg2.jpg')

.main-texts
  .text-1
    -ms-writing-mode: tb-rl
    writing-mode: vertical-rl
    position: absolute
    right: 50px
    top: 130px
    font-size: 30px
    letter-spacing: 0.5em
    font-family: 'Noto Serif JP', serif

  .text-2
    position: absolute
    left: 30px
    top: 530px
    font-size: 10px
    font-family: 'Noto Serif JP', serif

.texts
  position: absolute
  top: 80px
  left: 0
  padding: 20px
  box-sizing: border-box
  font-size: 10px

.text
  margin-bottom: 10px
  line-height: 24px

.part
  display: inline-block
</style>
